import { render, staticRenderFns } from "./chateau-pichon-longueville-baron.vue?vue&type=template&id=91bccb72&scoped=true"
import script from "./chateau-pichon-longueville-baron.vue?vue&type=script&lang=js"
export * from "./chateau-pichon-longueville-baron.vue?vue&type=script&lang=js"
import style0 from "./chateau-pichon-longueville-baron.vue?vue&type=style&index=0&id=91bccb72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bccb72",
  null
  
)

export default component.exports